import { useTranslation } from 'react-i18next'
import type { MeetingLanguage } from '@hub/contracts'
import { cn } from '@/lib/utils'

/**
 * The meeting-language picker (PLAN-085 D6, board m5gc #1): sv/en as a
 * segmented control. The language is pinned per meeting — Whisper's hint,
 * the live summary and the final notes all follow it — so both the schedule
 * dialog and the instant-start dialog ask the same question the same way.
 */
export function MeetingLanguageToggle({
  value,
  onChange,
  disabled,
}: {
  value: MeetingLanguage
  onChange: (language: MeetingLanguage) => void
  disabled?: boolean
}) {
  const { t } = useTranslation('meetings')
  return (
    <div role="radiogroup" className="flex overflow-hidden rounded-lg border">
      {(['sv', 'en'] as const).map((code) => (
        <button
          key={code}
          type="button"
          role="radio"
          aria-checked={value === code}
          disabled={disabled}
          onClick={() => onChange(code)}
          className={cn(
            'flex-1 px-3 py-1.5 text-sm font-medium transition-colors',
            value === code
              ? 'bg-primary text-primary-foreground'
              : 'text-muted-foreground hover:text-foreground bg-transparent'
          )}
        >
          {code === 'sv' ? t('create.languageSv') : t('create.languageEn')}
        </button>
      ))}
    </div>
  )
}
